import "./Pictures.css";
import React, { useEffect, useState } from "react";
import { Button } from "./Button";
import picture1 from "../images/gabinet-glowne-min.png";
import picture2 from "../images/gabinet-fotel-min.png";
import picture3 from "../images/gabinet-aneks-min.png";
import picture4 from "../images/gabinet-rentgen-min.png";

export const Pictures = () => {
    let [index, setIndex] = useState(0);
    const picturesList = [picture1, picture2, picture3, picture4];

    useEffect(() => {
    }, [index]);

    const handleShowPictures = () => {
        const button_show = document.getElementById("show_images_button");
        const button_hide = document.getElementById("hide_images_button");
        const images = document.getElementById("images_wrapper");
        const info_text = document.getElementById("pictures_info");
        const previous = document.getElementById("previous");
        const next = document.getElementById("next");
        button_show.classList.toggle("active_show_pictures");
        button_hide.classList.toggle("active_hide_pictures");
        images.classList.toggle("active_images_wrapper");
        info_text.classList.toggle("active_info_text");
        previous.classList.toggle("active_previous");
        next.classList.toggle("active_next");
    };

    const nextPicture = () => {
        setIndex((index + 1) % picturesList.length);
    };

    const previousPicture = () => {
        setIndex((index - 1 + picturesList.length) % picturesList.length);
    };

    return (
        <div className="block" id="Pictures">
            <div className="block_content">
                <h1>
                    Zdjęcia <i className="fa-solid fa-image"></i>
                </h1>
                <span id="pictures_info">Zobacz jak wygląda gabinet.</span>
                <div id="images_wrapper">
                    <img alt="zdjęcia gabinetu" src={picturesList[index]}></img>
                </div>
                <i
                    className="fa-solid fa-angle-left change_photo_button"
                    id="previous"
                    onClick={previousPicture}
                ></i>
                <i
                    className="fa-solid fa-angle-right change_photo_button"
                    id="next"
                    onClick={nextPicture}
                ></i>
                <Button
                    class="show_pictures button"
                    text="Pokaż zdjęcia"
                    icon="fa-solid fa-images"
                    onClick={handleShowPictures}
                    id="show_images_button"
                />
                <Button
                    class="show_pictures button"
                    text="Ukryj"
                    icon="fa-solid fa-eye-slash"
                    onClick={handleShowPictures}
                    id="hide_images_button"
                />
            </div>
        </div>
    );
};
